// src/config/prompts.js



const PROMPTS = {
  // Version for cache control
  version: "1.0.0",
  lastUpdated: "2025-10-13T00:00:00.000Z",
  
  // Base system prompts
  base: {
    GURU_BASE: "You are Guru ji, wise astrologer.",
    QUICK: "Keep response SHORT (30-50 words max). Simple language.",
    NORMAL: "Keep response MODERATE (80-150 words). Balanced, clear explanation.",
    DETAILED: "Provide detailed response max (180-250 words). Thorough, step-by-step.",
    GURU_TONE: "Warm, caring tone."
  },
  
  // Response length settings with word limits
  responseLength: {
    QUICK: {
      label: "Quick",
      maxWords: 50,
      description: "Short, concise answers (30-50 words)"
    },
    NORMAL: {
      label: "Normal",
      maxWords: 150,
      description: "Balanced explanations (80-150 words)"
    },
    DETAILED: {
      label: "Detailed",
      maxWords: 250,
      description: "Comprehensive analysis (180-250 words)"
    }
  },

  // Question types
  questionTypes: {
    GENERAL: {
      value: "general",
      label: "General Question",
      description: "Comprehensive astrological reading"
    },
    FOLLOWUP: {
      value: "followup",
      label: "Follow-up",
      description: "Quick clarification on previous answer"
    },
    TECHNICAL: {
      value: "technical",
      label: "Technical Analysis",
      description: "Detailed planetary positions and chart analysis"
    },
    REMEDY: {
      value: "remedy",
      label: "Remedies",
      description: "Practical solutions and rituals"
    }
  },
  
    // ✅ Message Type Codes
  messageTypes: {
    FH: 'FreeHoroscope',    
    FLUP: 'followup',       
    RM: 'remedy',             
    TL: 'technical',     
    NQ: 'New'   
  },
  // Languages with display names and placeholders
  languages: {
    ENGLISH: {
      INSTRUCTION: "Respond in clear English only. Use simple, easy-to-understand words.",
      DISPLAY_NAME: "English",
      PLACEHOLDER: "Your stars hold the answers Ask about life, career, love, health, or destiny – and get personalized guidance now!"
    },
    HINDI: {
      INSTRUCTION: "Respond in pure Hindi only. Use Devanagari script. हिंदी में जवाब दें।",
      DISPLAY_NAME: "हिंदी (Hindi)",
      PLACEHOLDER: "स्वागत है अपना ज्योतिष से जुड़ा प्रश्न पूछिए, आइए देखें सितारे क्या संकेत दे रहे हैं।"
    },
    HINGLISH: {
      INSTRUCTION: "Respond in Hinglish (Hindi written in English). Mix Hindi words with English script.",
      DISPLAY_NAME: "Hinglish (Hindi + English)",
      PLACEHOLDER: "Swagat hai Apna astrology se related question poochhiye, chaliye dekhte hain sitare kya batate hain."
    },
    TAMIL: {
      INSTRUCTION: "தமிழில் மட்டும் பதிலளிக்கவும். தெளிவான மற்றும் எளிய சொற்களை பயன்படுத்தவும்.",
      DISPLAY_NAME: "தமிழ் (Tamil)",
      PLACEHOLDER: "வணக்கம் உங்கள் ஜோதிட கேள்வியை கேளுங்கள்"
    },
    TELUGU: {
      INSTRUCTION: "దయచేసి తెలుగులో మాత్రమే సమాధానం ఇవ్వండి. సరళమైన భాషను ఉపయోగించండి.",
      DISPLAY_NAME: "తెలుగు (Telugu)",
      PLACEHOLDER: "స్వాగతం మీ జ్యోతిష్య ప్రశ్న అడగండి"
    }
  },

  buttonLabels: {
    ENGLISH: {
      FOLLOWUP: 'Follow-up',
      REMEDIES: 'Remedies',
      TECHNICAL: 'Technical',
      NEW: 'New Question'
    },
    HINDI: {
      FOLLOWUP: 'अनुवर्ती प्रश्न',
      REMEDIES: 'उपाय',
      TECHNICAL: 'तकनीकी विश्लेषण',
      NEW: 'नया प्रश्न'
    },
    HINGLISH: {
      FOLLOWUP: 'Follow-up',
      REMEDIES: 'Upaay',
      TECHNICAL: 'Technical',
      NEW: 'Naya Sawal'
    },
    TAMIL: {
      FOLLOWUP: 'தொடர் கேள்வி',
      REMEDIES: 'தீர்வுகள்',
      TECHNICAL: 'தொழில்நுட்ப பகுப்பாய்வு',
      NEW: 'புதிய கேள்வி'
    },
    TELUGU: {
      FOLLOWUP: 'తదుపరి ప్రశ్న',
      REMEDIES: 'పరిష్కారాలు',
      TECHNICAL: 'సాంకేతిక విశ్లేషణ',
      NEW: 'కొత్త ప్రశ్న'
    }
  },

  // Religion-specific contexts
  religion: {
    ISLAM: {
      CONTEXT: "User is Muslim. Use Islamic terms like 'Insha'Allah', 'Alhamdulillah'. No Hindu mantras.",
      GREETING: "Assalamu Alaikum",
      BLESSING: "Allah's blessings"
    },
    CHRISTIANITY: {
      CONTEXT: "User is Christian. Use Christian terms like 'God bless', 'By God's grace'.",
      GREETING: "May God bless you",
      BLESSING: "God's grace"
    },
    SIKHISM: {
      CONTEXT: "User is Sikh. Use 'Waheguru', 'Sat Sri Akal'.",
      GREETING: "Sat Sri Akal",
      BLESSING: "Waheguru's blessings"
    },
    BUDDHISM: {
      CONTEXT: "User is Buddhist. Use karma, dharma, mindfulness concepts.",
      GREETING: "May Buddha's wisdom guide you",
      BLESSING: "Buddha's wisdom"
    },
    JAINISM: {
      CONTEXT: "User is Jain. Use 'Jai Jinendra', ahimsa (non-violence) concepts.",
      GREETING: "Jai Jinendra",
      BLESSING: "Tirthankara's guidance"
    },
    JUDAISM: {
      CONTEXT: "User is Jewish. Use 'Shalom', 'Baruch Hashem' (Blessed is God).",
      GREETING: "Shalom",
      BLESSING: "Hashem's blessings"
    },
    ZOROASTRIANISM: {
      CONTEXT: "User is Zoroastrian. Use 'Asha Vahishta', Ahura Mazda concepts.",
      GREETING: "Asha Vahishta",
      BLESSING: "Ahura Mazda's light"
    },
    BAHAI: {
      CONTEXT: "User is Baháʼí. Use 'Allah-u-Abha', Bahá'u'lláh teachings.",
      GREETING: "Allah-u-Abha",
      BLESSING: "Bahá'u'lláh's guidance"
    },
    HINDU: {
      CONTEXT: "User is Hindu. Use traditional Vedic/Hindu terms freely.",
      GREETING: "Namaste",
      BLESSING: "Divine blessings"
    },
    OTHER: {
      CONTEXT: "User follows other spiritual path. Use universal spiritual terms.",
      GREETING: "Divine blessings",
      BLESSING: "Universal blessings"
    }
  },
  
  // Typing indicator messages
  typing: {
    ISLAM: [
      "AastroG is seeking Allah's guidance for you...",
      "AastroG is consulting the divine wisdom, Insha'Allah...",
      "AastroG is reading your cosmic patterns with Allah's blessings...",
      "AastroG is in spiritual meditation for your question..."
    ],
    CHRISTIANITY: [
      "AastroG is seeking God's guidance for you...",
      "AastroG is praying for divine wisdom...",
      "AastroG is reading your celestial chart with God's grace...",
      "AastroG is in prayer for your spiritual question..."
    ],
    SIKHISM: [
      "AastroG is seeking Waheguru's guidance...",
      "AastroG is consulting with divine wisdom...",
      "AastroG is analyzing your cosmic energy with Waheguru's blessings...",
      "AastroG is in meditation with the Guru's teachings..."
    ],
    BUDDHISM: [
      "AastroG is seeking Buddha's wisdom for you...",
      "AastroG is meditating on your karmic patterns...",
      "AastroG is following the path of enlightenment...",
      "AastroG is in mindful meditation for your question..."
    ],
    HINDU: [
      "AastroG is consulting the ancient Vedic texts...",
      "AastroG is reading your celestial birth chart...",
      "AastroG is analyzing your cosmic energy patterns...",
      "AastroG is meditating on your divine question... "
    ]
  },
  
   greetings: {
    ENGLISH: "Welcome! Your cosmic journey with AastroG begins...",
    HINDI: "स्वागत है! आपकी ज्योतिषीय यात्रा आस्ट्रोजी के साथ शुरू होती है...",
    HINGLISH: "Namaste! Aapki cosmic journey AastroG ke saath shuru hoti hai..."
  },

  // Add this after the greetings section
welcome: {
  ENGLISH: "Welcome, {name}! 🌌 Your personalized cosmic journey begins here with AastroG – guided by wisdom, powered by technology.",
  HINDI: "स्वागत है, {name} जी! 🌠 आपकी व्यक्तिगत ज्योतिषीय यात्रा अब आस्ट्रोजी के साथ आरंभ होती है – ज्ञान और तकनीक का संगम।",
  HINGLISH: "Namaste {name} Ji! 🌟 Aapki personalized cosmic journey ab shuru hoti hai AastroG ke saath – jahaan technology milti hai AastroG ke gyaan se."
},


  // Template prompts
  template: {
    HOROSCOPE_PROMPT: "Provide today's horoscope in 25-30 words. Keep positive, actionable.",
    QUESTION_TEMPLATE: "Respond as Guru ji with {religion} context.",
    USER_PROFILE: "User: {name}, {religion}, Born: {birthDate} at {birthTime} in {birthPlace}.",
    ERROR_NETWORK: "the cosmic connection seems disturbed at this moment. May {blessing} be with you, the divine energies are temporarily realigning. Please try again in a moment, my child. **Peace be with you...** 🙏✨"
  },
 suggestions: {
    ENGLISH: [
      // 🌌 Life Purpose & General (1–20)
      "What is my life purpose according to my birth chart?",
      "Am I destined for fame or recognition?",
      "Which phase of life will be most successful for me?",
      "What is my true personality based on my horoscope?",
      "Will I have a stable and peaceful life?",
      "Am I facing any doshas (manglik, kaal sarp, pitru dosh, etc.) in my chart?",
      "Will I travel abroad permanently?",
      "Which country or city is best for me to live in?",
      "Will I achieve spiritual growth in this lifetime?",
      "What are my strengths and weaknesses astrologically?",
      "What past life karma is affecting my present?",
      "Which planetary period (Mahadasha) will change my life?",
      "Am I under Shani Sade Sati or Dhaiya? What does it mean?",
      "How will my 2025 (or any year) be astrologically?",
      "What is my lucky gemstone?",
      "Which god/goddess should I worship for success?",
      "What are my lucky colors and numbers?",
      "When will I find peace and stability in life?",
      "Is my destiny strong or weak?",
      "What remedies can balance my planets?",

      // 💼 Career & Education (21–40)
      "Which career suits me best – job, business, or creative field?",
      "Am I in the right profession according to astrology?",
      "When will I get a stable job?",
      "Will I get a government job?",
      "Do I have chances to clear competitive exams?",
      "Should I pursue higher education or work?",
      "Will I be successful if I study abroad?",
      "Which field of study is best for me?",
      "When will I get a promotion?",
      "Will I face sudden job loss or instability?",
      "Is freelancing/business good for me?",
      "What kind of business will bring me success?",
      "Do I have chances to become a leader/CEO?",
      "Which planets control my professional life?",
      "What is the right time to switch jobs?",
      "Will I work in IT/finance/arts/medicine (specific field)?",
      "Is foreign career growth indicated in my chart?",
      "How can I overcome obstacles in my career?",
      "Will my hard work be rewarded soon?",
      "Which period will bring the peak of my career success?",

      // ❤️ Love & Relationships (41–60)
      "When will I meet my soulmate?",
      "Is love marriage or arranged marriage in my destiny?",
      "Will my family approve of my love marriage?",
      "Is my partner loyal and compatible with me?",
      "Do I have chances of inter-caste or inter-religion marriage?",
      "When will I get married?",
      "Will I have more than one marriage?",
      "How will my married life be?",
      "Do I have chances of separation or divorce?",
      "Will I reunite with my ex-partner?",
      "What kind of life partner is destined for me?",
      "Which zodiac sign is most compatible with me?",
      "Will I face delays in marriage?",
      "Are there any marriage-related doshas in my kundli?",
      "Will my partner support my career?",
      "Will I have a love story that lasts forever?",
      "How many children will I have?",
      "Will my children be successful?",
      "What remedies can improve my married life?",
      "How will my relationship with in-laws be?",

      // 💰 Finance & Wealth (61–80)
      "Will I ever become rich?",
      "When will I see financial stability?",
      "Which source of income is most favorable for me?",
      "Do I have chances of sudden wealth?",
      "Will I win a lottery or jackpot?",
      "Are there financial ups and downs in my horoscope?",
      "Which investments are good for me – stock, gold, or property?",
      "Will I inherit property from family?",
      "Is real estate a good option for me?",
      "When will I clear my debts?",
      "Will I face financial losses in the future?",
      "What is the right time to buy a house?",
      "What is the right time to buy a vehicle?",
      "Do I have dhan yoga in my horoscope?",
      "Will I be financially independent?",
      "Should I take financial risks now?",
      "Will I become a self-made millionaire?",
      "What is the financial impact of my current planetary period?",
      "Which planet rules my wealth?",
      "What remedies can improve my financial growth?",

      // 🧘 Health & Well-being (81–90)
      "What health problems are shown in my horoscope?",
      "Do I have a long life?",
      "Will I suffer from chronic illness?",
      "How can I maintain good health astrologically?",
      "Which planet affects my health the most?",
      "Will I recover from my current illness?",
      "Do I need to be careful about accidents?",
      "What is the best time for surgery or treatment?",
      "Which yoga or meditation will suit me?",
      "Which remedies protect me from health issues?",

      // 🌠 Spirituality & Miscellaneous (91–100)
      "What is my spiritual path?",
      "Do I have a strong intuition or psychic abilities?",
      "Will I ever become a spiritual leader or healer?",
      "Which mantra or puja is best for me?",
      "How do planets affect my karma?",
      "What lessons am I supposed to learn in this life?",
      "Do I have yogas for moksha (liberation)?",
      "Which deity should I worship for blessings?",
      "Are my dreams connected to astrology?",
      "How can I balance my mind, body, and soul using astrology?"
    ],

    HINDI: [
      // 🌌 जीवन उद्देश्य (1–20)
      "मेरी जन्म कुंडली के अनुसार मेरा जीवन उद्देश्य क्या है?",
      "क्या मैं प्रसिद्धि या पहचान के लिए नियत हूं?",
      "मेरे जीवन का कौन सा चरण सबसे सफल होगा?",
      "मेरी कुंडली के अनुसार मेरा असली व्यक्तित्व क्या है?",
      "क्या मेरा जीवन स्थिर और शांतिपूर्ण होगा?",
      "क्या मेरी कुंडली में कोई दोष (मंगलिक, कालसर्प, पितृ दोष आदि) है?",
      "क्या मैं स्थायी रूप से विदेश यात्रा करूंगा?",
      "मेरे लिए कौन सा देश या शहर सबसे अच्छा रहेगा?",
      "क्या मुझे इस जीवन में आध्यात्मिक उन्नति मिलेगी?",
      "मेरी ज्योतिषीय ताकतें और कमजोरियां क्या हैं?",
      "कौन सा पिछले जन्म का कर्म मेरे वर्तमान को प्रभावित कर रहा है?",
      "कौन सी महादशा मेरे जीवन को बदल देगी?",
      "क्या मैं शनि साढ़े साती या ढैय्या से गुजर रहा हूं? इसका क्या मतलब है?",
      "मेरा 2025 (या कोई भी वर्ष) ज्योतिषीय रूप से कैसा होगा?",
      "मेरा भाग्यशाली रत्न कौन सा है?",
      "सफलता के लिए मुझे किस देवता/देवी की पूजा करनी चाहिए?",
      "मेरे शुभ रंग और अंक कौन से हैं?",
      "मुझे जीवन में शांति और स्थिरता कब मिलेगी?",
      "क्या मेरी किस्मत मजबूत है या कमजोर?",
      "मेरे ग्रहों को संतुलित करने के लिए क्या उपाय हैं?",

      // 💼 करियर और शिक्षा (21–40)
      "मेरे लिए कौन सा करियर सही है – नौकरी, व्यवसाय या रचनात्मक क्षेत्र?",
      "क्या मैं ज्योतिष के अनुसार सही पेशे में हूं?",
      "मुझे स्थायी नौकरी कब मिलेगी?",
      "क्या मुझे सरकारी नौकरी मिलेगी?",
      "क्या मेरे पास प्रतियोगी परीक्षाओं में सफल होने के योग हैं?",
      "क्या मुझे उच्च शिक्षा लेनी चाहिए या काम करना चाहिए?",
      "क्या मैं विदेश में पढ़ाई करके सफल होऊंगा?",
      "मेरे लिए कौन सा अध्ययन क्षेत्र सबसे अच्छा है?",
      "मुझे पदोन्नति कब मिलेगी?",
      "क्या मुझे अचानक नौकरी छूटने या अस्थिरता का सामना करना पड़ेगा?",
      "क्या मेरे लिए फ्रीलांसिंग/व्यवसाय अच्छा रहेगा?",
      "किस प्रकार का व्यवसाय मुझे सफलता देगा?",
      "क्या मेरे पास नेता/सीईओ बनने के योग हैं?",
      "कौन से ग्रह मेरे पेशेवर जीवन को नियंत्रित करते हैं?",
      "नौकरी बदलने का सही समय कब है?",
      "क्या मैं आईटी/वित्त/कला/चिकित्सा (विशिष्ट क्षेत्र) में काम करूंगा?",
      "क्या मेरी कुंडली में विदेश करियर का संकेत है?",
      "मैं अपने करियर में बाधाओं को कैसे दूर करूं?",
      "क्या मेरी मेहनत का फल जल्द मिलेगा?",
      "मेरे करियर की सफलता का शिखर किस अवधि में आएगा?",

      // ❤️ प्रेम और संबंध (41–60)
      "मैं अपने जीवन साथी से कब मिलूंगा?",
      "क्या मेरी नियति में लव मैरिज है या अरेंज मैरिज?",
      "क्या मेरा परिवार मेरी लव मैरिज को स्वीकार करेगा?",
      "क्या मेरा साथी वफादार और अनुकूल होगा?",
      "क्या मेरे पास अंतरजातीय या अंतरधार्मिक विवाह के योग हैं?",
      "मेरी शादी कब होगी?",
      "क्या मेरी एक से अधिक शादी होगी?",
      "मेरा वैवाहिक जीवन कैसा रहेगा?",
      "क्या मेरे पास अलगाव या तलाक के योग हैं?",
      "क्या मैं अपने पूर्व साथी से दोबारा मिलूंगा?",
      "मेरे लिए किस प्रकार का जीवनसाथी नियत है?",
      "कौन सा राशि चिह्न मेरे लिए सबसे अनुकूल है?",
      "क्या मेरी शादी में देरी होगी?",
      "क्या मेरी कुंडली में विवाह से संबंधित कोई दोष है?",
      "क्या मेरा साथी मेरे करियर को समर्थन देगा?",
      "क्या मेरी प्रेम कहानी हमेशा के लिए चलेगी?",
      "मेरे कितने बच्चे होंगे?",
      "क्या मेरे बच्चे सफल होंगे?",
      "मेरे वैवाहिक जीवन को बेहतर बनाने के उपाय क्या हैं?",
      "ससुराल पक्ष के साथ मेरा संबंध कैसा रहेगा?",

      // 💰 वित्त और धन (61–80)
      "क्या मैं कभी अमीर बनूंगा?",
      "मुझे वित्तीय स्थिरता कब मिलेगी?",
      "मेरे लिए कौन सा आय स्रोत सबसे अनुकूल है?",
      "क्या मेरे पास अचानक धन प्राप्ति के योग हैं?",
      "क्या मैं लॉटरी या जैकपॉट जीतूंगा?",
      "क्या मेरी कुंडली में वित्तीय उतार-चढ़ाव हैं?",
      "मेरे लिए कौन सा निवेश अच्छा रहेगा – शेयर, सोना या संपत्ति?",
      "क्या मुझे परिवार से संपत्ति विरासत में मिलेगी?",
      "क्या मेरे लिए रियल एस्टेट अच्छा विकल्प है?",
      "मैं अपने कर्ज कब चुकाऊंगा?",
      "क्या मुझे भविष्य में वित्तीय नुकसान का सामना करना पड़ेगा?",
      "घर खरीदने का सही समय कब है?",
      "वाहन खरीदने का सही समय कब है?",
      "क्या मेरी कुंडली में धन योग है?",
      "क्या मैं आर्थिक रूप से स्वतंत्र होऊंगा?",
      "क्या मुझे अभी वित्तीय जोखिम लेना चाहिए?",
      "क्या मैं सेल्फ-मेड करोड़पति बनूंगा?",
      "मेरे वर्तमान ग्रह काल का मेरे वित्त पर क्या प्रभाव है?",
      "कौन सा ग्रह मेरी संपत्ति को नियंत्रित करता है?",
      "मेरी आर्थिक वृद्धि को बेहतर करने के उपाय क्या हैं?",

      // 🧘 स्वास्थ्य और कल्याण (81–90)
      "मेरी कुंडली में कौन सी स्वास्थ्य समस्याएं दिखाई देती हैं?",
      "क्या मेरी लंबी उम्र है?",
      "क्या मैं किसी पुरानी बीमारी से पीड़ित रहूंगा?",
      "मैं ज्योतिषीय रूप से अच्छा स्वास्थ्य कैसे बनाए रखूं?",
      "कौन सा ग्रह मेरे स्वास्थ्य को सबसे ज्यादा प्रभावित करता है?",
      "क्या मैं अपनी वर्तमान बीमारी से ठीक हो जाऊंगा?",
      "क्या मुझे दुर्घटनाओं से सावधान रहना चाहिए?",
      "सर्जरी या इलाज के लिए सबसे अच्छा समय कब है?",
      "मेरे लिए कौन सा योग या ध्यान सबसे उपयुक्त होगा?",
      "कौन से उपाय मुझे स्वास्थ्य समस्याओं से बचाते हैं?",

      // 🌠 अध्यात्म और विविध (91–100)
      "मेरा आध्यात्मिक मार्ग क्या है?",
      "क्या मेरे पास मजबूत अंतर्ज्ञान या मानसिक क्षमताएं हैं?",
      "क्या मैं कभी आध्यात्मिक नेता या हीलर बनूंगा?",
      "मेरे लिए कौन सा मंत्र या पूजा सबसे अच्छा है?",
      "ग्रह मेरे कर्मों को कैसे प्रभावित करते हैं?",
      "मुझे इस जीवन में कौन से सबक सीखने हैं?",
      "क्या मेरी कुंडली में मोक्ष योग है?",
      "आशीर्वाद के लिए मुझे किस देवता की पूजा करनी चाहिए?",
      "क्या मेरे सपने ज्योतिष से जुड़े हुए हैं?",
      "मैं ज्योतिष के माध्यम से मन, शरीर और आत्मा का संतुलन कैसे बना सकता हूं?"
    ],

    HINGLISH: [
      // 🌌 Life Purpose (1–20)
      "Meri kundli ke hisaab se mera life purpose kya hai?",
      "Kya main fame ya recognition ke liye destined hoon?",
      "Mere life ka kaunsa phase sabse successful hoga?",
      "Meri kundli ke hisaab se mera asli personality kya hai?",
      "Kya mera jeevan stable aur peaceful hoga?",
      "Kya meri kundli me dosh (Manglik, Kaal Sarp, Pitru Dosh, etc.) hai?",
      "Kya main permanently abroad shift ho jaunga?",
      "Mere liye kaunsa desh ya sheher best hoga?",
      "Kya main is janam me spiritual growth paaunga?",
      "Meri kundli ke strengths aur weaknesses kya hain?",
      "Kaunsa past life karma meri life ko affect kar raha hai?",
      "Kaunsi Mahadasha meri zindagi badal degi?",
      "Kya main Shani Sade Sati ya Dhaiya me hoon? Uska matlab kya hai?",
      "Mera 2025 (ya koi bhi year) jyotish ke hisaab se kaisa hoga?",
      "Mera lucky gemstone kaunsa hai?",
      "Success ke liye mujhe kis devta/devi ki pooja karni chahiye?",
      "Mere lucky colors aur numbers kaunse hain?",
      "Mujhe shanti aur stability life me kab milegi?",
      "Meri destiny strong hai ya weak?",
      "Mere grahon ko balance karne ke liye kya upay hain?",

      // 💼 Career & Education (21–40)
      "Mere liye kaunsa career sahi hai – job, business ya creative field?",
      "Kya main astrology ke hisaab se right profession me hoon?",
      "Mujhe stable job kab milegi?",
      "Kya mujhe government job milegi?",
      "Kya mere paas competitive exams clear karne ke chances hain?",
      "Mujhe higher education pursue karni chahiye ya work karna chahiye?",
      "Kya main abroad study karke successful ho paunga?",
      "Mere liye kaunsa field of study best hai?",
      "Mujhe promotion kab milega?",
      "Kya mujhe sudden job loss ya instability ka samna karna padega?",
      "Kya freelancing/business mere liye sahi hai?",
      "Kaunsa business mujhe success dilayega?",
      "Kya mere paas leader/CEO banne ke chances hain?",
      "Kaunse grah mere professional life ko control karte hain?",
      "Job switch karne ka sahi time kab hai?",
      "Kya main IT/finance/arts/medicine (specific field) me kaam karunga?",
      "Kya meri kundli me foreign career growth ke yog hain?",
      "Main apne career ke obstacles kaise overcome karun?",
      "Kya meri hard work ka fal jaldi milega?",
      "Mere career success ka peak period kaunsa hoga?",

      // ❤️ Love & Relationships (41–60)
      "Main apne soulmate se kab milunga?",
      "Meri destiny me love marriage hai ya arranged marriage?",
      "Kya mera family meri love marriage approve karega?",
      "Kya mera partner vafadar aur anukool hoga?",
      "Kya mere paas inter-caste ya inter-religion marriage ke chances hain?",
      "Meri shaadi kab hogi?",
      "Kya meri ek se zyada shaadi hogi?",
      "Mera married life kaisa hoga?",
      "Kya mere paas separation ya divorce ke chances hain?",
      "Kya main apne ex-partner ke saath wapas milunga?",
      "Mere liye kaunsa life partner destined hai?",
      "Kaunsi zodiac sign mere liye sabse compatible hai?",
      "Kya meri shaadi me delay hoga?",
      "Kya meri kundli me marriage related dosh hain?",
      "Kya mera partner meri career support karega?",
      "Kya meri love story hamesha ke liye chalegi?",
      "Mere kitne bachche honge?",
      "Kya mere bachche successful honge?",
      "Mere married life ko improve karne ke upay kya hain?",
      "Mera relationship in-laws ke saath kaisa hoga?",

      // 💰 Finance & Wealth (61–80)
      "Kya main kabhi ameer banunga?",
      "Mujhe financial stability kab milegi?",
      "Mere liye kaunsa income source sabse favorable hai?",
      "Kya mere paas sudden wealth ke chances hain?",
      "Kya main lottery ya jackpot jeetunga?",
      "Kya meri kundli me financial ups and downs hain?",
      "Mere liye kaunsa investment best hai – shares, sona ya property?",
      "Kya mujhe family se property inherit hogi?",
      "Kya real estate mere liye achha option hai?",
      "Main apne debts kab clear karunga?",
      "Kya mujhe future me financial losses face karne padenge?",
      "House buy karne ka sahi time kab hai?",
      "Vehicle kharidne ka sahi time kab hai?",
      "Kya meri kundli me dhan yoga hai?",
      "Kya main financially independent banunga?",
      "Kya mujhe abhi financial risk lena chahiye?",
      "Kya main self-made millionaire banunga?",
      "Mere current planetary period ka financial impact kya hai?",
      "Kaunsa grah meri wealth rule karta hai?",
      "Meri financial growth improve karne ke upay kya hain?",

      // 🧘 Health & Well-being (81–90)
      "Meri kundli me kaunse health problems dikh rahe hain?",
      "Kya meri long life hai?",
      "Kya main chronic illness se suffer karunga?",
      "Main astrology ke hisaab se good health kaise maintain karun?",
      "Kaunsa grah mere health ko sabse zyada affect karta hai?",
      "Kya main apni current illness se recover karunga?",
      "Kya mujhe accidents se bachna chahiye?",
      "Surgery ya treatment ke liye sabse acha time kab hai?",
      "Mere liye kaunsa yoga ya meditation best hoga?",
      "Kaunse upay mujhe health issues se protect karte hain?",

      // 🌠 Spirituality & Misc (91–100)
      "Mera spiritual path kya hai?",
      "Kya mere paas strong intuition ya psychic abilities hain?",
      "Kya main kabhi spiritual leader ya healer banunga?",
      "Mere liye kaunsa mantra ya puja best hai?",
      "Planets mere karma ko kaise affect karte hain?",
      "Mujhe is life me kaunse lessons seekhne hain?",
      "Kya meri kundli me moksha yog hai?",
      "Blessings ke liye mujhe kis devta ki pooja karni chahiye?",
      "Kya mere sapne astrology se connected hain?",
      "Main astrology ke through mind, body aur soul ka balance kaise banaun?"
    ]
  }

};

export default PROMPTS;
